// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_3c7W3","visuallyhidden":"_2OxpO","hide-text":"e91Nr","center":"_2JD-x","noprint":"_1PYgw","headline":"_24bbe"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-headline/styles/Headline.scss
 ** module id = 943
 ** module chunks = 1
 **/